import { createContext, useContext } from 'react';

export interface WorkspaceActions {
  /** Menu navigation returns to the filters and page last used in an existing tab. */
  href(path: string): string;
  confirmMarketChange(): Promise<boolean>;
}

export const WorkspaceContext = createContext<WorkspaceActions | null>(null);
export const WorkspacePageContext = createContext<((dirty: boolean) => void) | null>(null);

export function useWorkspace() {
  return useContext(WorkspaceContext);
}

/** Lets an existing page guard report unsaved work without blocking switches to preserved pages. */
export function useWorkspaceDirtyReporter() {
  return useContext(WorkspacePageContext);
}
